module.exports = {"title":"Contact me","layout":"page","path":"/contact","body":"<p>comming soon …</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/contact/index.md
// module id = 524
// module chunks = 0